import React from "react";
import {LinkPopover} from '@vedmarket/ui-kit';
import Typography from '@mui/material/Typography';
import {COLORS} from 'config/constants';
import {formatReferenceCopy} from 'utils/typography';
import {useTranslation} from "react-i18next";

import Tab from "@mui/material/Tab";
import NewButton from "../new-button";
import Tabs from "@mui/material/Tabs";

import {ADD_PAYMENT_FORM} from "../../index";

import './payment-tabs.scss';
import {numberWithSpaces} from "../../../../../../../../../../../utils/helpers";

type Props = {
    tabValue: number
    fields: any[]
    append: any
    initialValues: any
    startFieldsIndex?: number
    shouldAppendItem?: boolean
    shouldShowPaymentTitle?: boolean
    handleChange(event: React.SyntheticEvent, newValue: number): void
    getValues(s: string): any
    onClickNewButton?(): void
}

const PaymentTabs = ( {
  tabValue,
  handleChange,
  fields,
  getValues,
  append,
  initialValues,
  startFieldsIndex = 0,
  onClickNewButton,
  shouldAppendItem,
  shouldShowPaymentTitle = true,
} : Props ) => {

  const { t } = useTranslation();

  function a11yProps(index: number) {
    return {
      id: `bankCommission-tab-${index}`,
      'aria-controls': `bankCommission-tabpanel-${index}`,
    };
  }

  const handleClick = () => {
    if (shouldAppendItem) {
      append(initialValues);
    }
    if (onClickNewButton){
      onClickNewButton();
    }
  }

  const hasSomeValues = getValues(`payments.${0}.${ADD_PAYMENT_FORM.COMMISSION_PERCENTAGE}`);

  return (
    <div className='payment-tabs'>
      <div className='payment-tabs__navigation'>
        <Tabs
          value={tabValue}
          onChange={handleChange}
          sx={{
            minHeight: hasSomeValues || startFieldsIndex ? '60px' : '42px',
            width: 'max-content',
            minWidth: 0,
            maxWidth: '100%',
          }}
          variant='scrollable'
          scrollButtons='auto'
          allowScrollButtonsMobile
        >
          {fields.map((field, index) => {

            let currentPercent = field.commission_percentage || '';

            let currentAmount = field.payment_amount || '';

            let paymentTitle = '';

            if (index >= startFieldsIndex)   {
              currentPercent = getValues(`payments.${index - startFieldsIndex}.${ADD_PAYMENT_FORM.COMMISSION_PERCENTAGE}`);
              currentAmount = getValues(`payments.${index - startFieldsIndex}.${ADD_PAYMENT_FORM.PAYMENT_AMOUNT}`);
            }

            paymentTitle = currentPercent && currentAmount ? `${currentPercent}%, ${numberWithSpaces(currentAmount)} USD` : '';

            return (
              <Tab key={index} label={<span className='payments-tab'>
                <Typography variant='body2' component='span' sx={{
                  color: 'inherit',
                  fontWeight: 500,
                  lineHeight: '21px',
                  letterSpacing: 0,
                }}>
                  {formatReferenceCopy(`${t('calc__text__bankCommissions__payment')}-${index + 1}`)}
                </Typography>
                {shouldShowPaymentTitle && paymentTitle && (
                  <Typography variant='caption' component='span' sx={{
                    color: COLORS.LIGHT_TEXT_DISABLED,
                    fontSize: '12px',
                    lineHeight: '18px',
                    letterSpacing: 0,
                  }}>{formatReferenceCopy(paymentTitle)}</Typography>
                )}
              </span>} {...a11yProps(index)}/>
            )
          })}
        </Tabs>
        <NewButton append={handleClick} initialValues={initialValues}/>
      </div>
      <div className='payment-tabs__help'>
        <LinkPopover
          linkText={t('calc__help__paymentPartsLink')}
          text={<div className='payment-tabs__help-content'>
            <Typography variant='inherit'>
              {formatReferenceCopy(t('calc__help__paymentPartsSingle'))}
            </Typography>
            <Typography variant='inherit'>
              {formatReferenceCopy(t('calc__help__paymentPartsMultiple'))}
            </Typography>
          </div>}
        />
      </div>
    </div>
  );
}

export default PaymentTabs
